<template>
    <div class="pl-2 pr-2">
        <!-- HEADER -->
        <v-row v-if="showReport">
            <v-col cols="12">
                <v-switch style="display: inline-block;" class="mr-2" v-model="report.firstInspection" @change="updateReport('firstInspection')" dense label="Первичная проверка"></v-switch>
                <v-switch style="display: inline-block;" class="mr-2" v-model="report.testInspection" @change="updateReport('testInspection')" dense label="Тестовая проверка"></v-switch>
                <v-switch style="display: inline-block;" class="mr-2" v-model="deleteMode" dense label="Режим удаления вопросов"></v-switch>
                <v-btn class="info" target="_blank"
                       :href="`https://sbotapi.fitauto.ru/v3/reports/tp/${dealID}/report.pdf`">Посмотреть pdf-отчет
                </v-btn>
                <v-btn class="info ml-2" @click="moveFiles">Перенести файлы в медиа</v-btn>
                <v-btn class="info ml-2" color="success" @click="showAddStandartQuestionDialog" title="Доабвить вопрос стандартный вопрос."><v-icon>mdi-plus</v-icon></v-btn>
                <v-dialog v-model="dialogs.addStandartQuestion.show" persistent max-width="400px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Добавить вопрос</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                       Если вы не нашли в отчете обязательный вопрос, то вы можете добавить его в этомй форме.
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                                :items="adminsblocks"
                                                dense
                                                label="Блок вопросов"
                                                item-value="admin_block_id"
                                                item-text="admin_block_name"
                                                v-model="dialogs.addStandartQuestion.type"
                                                @change="getQuestions"
                                                required
                                        ></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="12">
                                        <v-select
                                                :disabled="dialogs.addStandartQuestion.type === null"
                                                :items="standartQuestions"
                                                :loading="dialogs.addStandartQuestion.loadQuestions"
                                                item-value="step_id"
                                                dense
                                                return-object
                                                item-text="question"
                                                label="Вопрос"
                                                v-model="dialogs.addStandartQuestion.selectedQuestion"
                                                required
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="dialogs.addStandartQuestion.show = false">Отмена</v-btn>
                            <v-btn color="success" text @click="addStandartQuestion">Добавить</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-col>
        </v-row>
        <!-- REPORT -->
        <v-row v-if="showReport">
            <v-col cols="12">
                <v-tabs v-model="tab" background-color="deep-purple accent-4" class="elevation-2" dark>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tab-main">Информация о проверке</v-tab>
                    <v-tab href="#tab-report">Основной отчет</v-tab>
                    <v-tab href="#tab-docs">Документы</v-tab>
                    <v-tab href="#tab-final">Итоги</v-tab>
                    <v-tab href="#tab-photo">Фото</v-tab>
                    <v-tab href="#tab-audio">Аудио</v-tab>
                    <v-tab href="#tab-video">Видео</v-tab>
                    <v-tab-item value="tab-main">
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table dense fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left" width="500">Параметр</th>
                                            <th class="text-left">Значение</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td>Дата проведения проверки:</td>
                                            <td><v-text-field v-model="report.dealData.real_start_date" type="date" @change="updateReport"></v-text-field></td>
                                        </tr>
                                        <tr v-for="(qst, index) in report.head" :key="index">
                                            <td>{{ qst.question }}</td>
                                            <td>
                                                {{ qst.answer }} <v-btn text small @click="headEditOn(index)"><v-icon small>mdi-pencil</v-icon></v-btn>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-dialog v-model="headEditor.show" max-width="60%">
                                        <v-card>
                                            <v-card-title class="title">Редактирование ответа ТП</v-card-title>
                                            <v-card-text>
                                                <v-row>
                                                    <v-text-field v-if="!!headEditor.show" outlined v-model="report.head[headEditor.index].answer"></v-text-field>
                                                </v-row>
                                            </v-card-text>
                                            <v-card-actions>
                                                <v-divider></v-divider>
                                                <v-btn text color="info" @click="headEditCancel(headEditor.index)">Отмена</v-btn>
                                                <v-btn text color="success" @click="headEditSave">Сохранить</v-btn>
                                            </v-card-actions>
                                        </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-content class="pa-2">Дополнительные вопросы</v-content>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">
                                <v-simple-table dense fixed-header>
                                    <template v-slot:default>
                                        <thead>
                                        <tr>
                                            <th class="text-left" width="500">Вопрос</th>
                                            <th class="text-left">Значение</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(qst, index) in report.additional" :key="index">
                                            <td>{{ qst.question }}</td>
                                            <td>{{ qst.answer }} <v-btn text small @click="addEditOn(index)"><v-icon small>mdi-pencil</v-icon></v-btn></td>
                                        </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                                <v-dialog v-model="addEditor.show" max-width="60%">
                                    <v-card>
                                        <v-card-title class="title">Редактирование ответа ТП</v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-text-field v-if="!!addEditor.show" outlined v-model="report.additional[addEditor.index].answer"></v-text-field>
                                            </v-row>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-divider></v-divider>
                                            <v-btn text color="info" @click="addEditCancel(addEditor.index)">Отмена</v-btn>
                                            <v-btn text color="success" @click="addEditSave">Сохранить</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>

                    </v-tab-item>
                    <v-tab-item value="tab-report">

                        <v-simple-table dense fixed-header height="500px">
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left" width="300">Вопрос</th>
                                    <th class="text-left">Ответ</th>
                                    <th class="text-center" width="100">Файл</th>
                                    <th class="text-center" width="100">Предыдущая оценка</th>
                                    <th class="text-center" width="100">Оценка</th>
                                    <th class="text-center" width="100">Итоговая оценка</th>
                                    <th class="text-center" width="100">Комментарий</th>
                                    <th class="text-center" width="100">Исключить</th>
                                    <th class="text-center" width="100" v-if="deal && deal.STAGE_ID === 'C30:2'">Файл
                                        СТО
                                    </th>
                                    <th class="text-center" width="100" v-if="deal && deal.STAGE_ID === 'C30:2'">
                                        Комментарий СТО
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <ShopperShowTableBlock
                                        v-for="(block, index) in mainRows" :key="index" :block="block"
                                        :mode="mode"
                                        :stage="deal.STAGE_ID"
                                        @selectfile="selectPhoto"
                                        @viewfile="viewPhoto"
                                        @viewcomment="viewComment"
                                        @editcomment="editComment"
                                        @updatereport="updateReport('ShopperShowTableBlock')"
                                        @deletedouble="deleteDouble"
                                        :deletemode="deleteMode"
                                >
                                </ShopperShowTableBlock>

                                <tr>
                                    <td class="amber lighten-1" colspan="11">Дополнительные замечания от менеджера
                                        проекта ТП
                                        <v-btn v-if="mode === 'manager'" color="success" class="ma-1" x-small
                                               @click="addAdditionalQuestion">
                                            <v-icon small>mdi-plus</v-icon>
                                        </v-btn>
                                    </td>
                                </tr>
                                <ShopperAdditionalRow
                                        v-for="(qst, index) in additionalRows" :key="mainRows.length + index"
                                        @updatereport="updateReport('ShopperAdditionalRow')"
                                        @editcomment="editComment"
                                        @selectfile="selectPhoto"
                                        @viewfile="viewPhoto"
                                        @viewcomment="viewComment"
                                        @deletequestion="delAdditionalQuestion"
                                        :stage="deal.STAGE_ID"
                                        :mode="mode"
                                        :ind="index"
                                        :data="qst">
                                </ShopperAdditionalRow>

                                </tbody>
                            </template>
                        </v-simple-table>

                    </v-tab-item>
                    <v-tab-item value="tab-docs">
                        <v-simple-table dense fixed-header height="500px">
                            <template v-slot:default>
                                <thead>
                                <tr>
                                    <th class="text-left" width="300">Вопрос</th>
                                    <th class="text-left">Ответ</th>
                                    <th class="text-left" width="100">Файл</th>
                                    <th class="text-left" width="100">Предыдущая оценка</th>
                                    <th class="text-left" width="100">Оценка</th>
                                    <th class="text-left" width="100">Итоговая оценка</th>
                                    <th class="text-left" width="100">Комментарий</th>
                                    <th class="text-left" width="100">Исключить</th>
                                    <th class="text-left" width="100" v-if="deal && deal.STAGE_ID === 'C30:2'">Файл
                                        СТО
                                    </th>
                                    <th class="text-left" width="100" v-if="deal && deal.STAGE_ID === 'C30:2'">
                                        Комментарий СТО
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <ShopperDocumentsRow
                                        v-for="(block, index) in documentsRows"
                                        @selectfile="selectPhoto"
                                        @viewfile="viewPhoto"
                                        @viewcomment="viewComment"
                                        @editcomment="editComment"
                                        @updatereport="updateReport('ShopperDocumentsRow')"
                                        @deletedouble="deleteDoubleDoc"
                                        :deletemode="deleteMode"
                                        :mode="mode"
                                        :stage="deal.STAGE_ID"
                                        :key="index"
                                        :block="block"

                                ></ShopperDocumentsRow>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-tab-item>
                    <v-tab-item value="tab-final">
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <v-btn @click="calculatePercentage">Пересчитать</v-btn>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table dense fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left">Название</th>
                                                <th class="text-left" width="30%">Значение</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                                <td>Общее количество вопросов:</td>
                                                <td>{{ report.final.percents.allQuestions }}</td>
                                            </tr>
                                            <tr>
                                                <td>Количество исключенных вопросов:</td>
                                                <td>{{ report.final.percents.exluded }}</td>
                                            </tr>
                                            <tr>
                                                <td>Итого максимум баллов:</td>
                                                <td>{{ report.final.percents.maximum }}</td>
                                            </tr>
                                            <tr>
                                                <td>Начислено баллов:</td>
                                                <td>{{ report.final.percents.standartPoints }}</td>
                                            </tr>
                                            <tr>
                                                <td>Максимум баллов за блок "Превосходя ожидания":</td>
                                                <td>{{ report.final.percents.bonus * 2 }}</td>
                                            </tr>
                                            <tr>
                                                <td>Начислено баллов за блок "Превосходя ожидания":</td>
                                                <td>{{ report.final.percents.bonusPoints }}</td>
                                            </tr>
                                            <tr>
                                                <td>Итого начислено:</td>
                                                <td>{{ report.final.percents.finalPoints }}</td>
                                            </tr>
                                            <tr class="success">
                                                <td>Результат проверки:</td>
                                                <td>{{ report.final.percents.percent }}%</td>
                                            </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>

                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-simple-table fixed-header dense>
                                        <template v-slot:default>
                                            <thead>
                                            <tr>
                                                <th class="text-left" width="300">Нарушение ШБ</th>
                                                <th class="text-center" width="90">ШБ Авто</th>
                                                <th class="text-left" width="90">Корр</th>
                                                <th class="text-center" width="90">Подитог ШБ</th>
                                                <th class="text-left">Комментарий</th>
                                                <th class="text-left" v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    width="90">Списать
                                                </th>
                                                <th class="text-left" v-if="deal != null && deal.STAGE_ID === 'C30:2'">
                                                    Комментарий
                                                </th>
                                                <th class="text-left" v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    width="90">Итог ШБ
                                                </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr :class="(block.type === 1) ? `yellow lighten-3` : (block.type === 3) ? `red lighten-1` : ``"
                                                v-for="(block, index) in report.final.penalty">
                                                <td>{{ block.name }}</td>
                                                <td class="text-center">{{ block.points }}</td>
                                                <td>
                                                    <v-text-field solo flat dense type="number" min="-10" max="10"
                                                                  v-if="mode === 'manager'" @change="calculatePenalty"
                                                                  v-model="block.correction"
                                                                  :step="block.type === 2 ? 0.1 : 1"></v-text-field>
                                                    <div v-else>{{ block.correction }}</div>
                                                </td>
                                                <td class="text-center">{{ block.final }}</td>
                                                <td>
                                                    <v-textarea rows="2" solo flat dense @change="updateReport('comment change')"
                                                                class="mt-2" v-if="mode === 'manager'"
                                                                placeholder="Оставьте комментарий для франчайзи и менеджера по сопровождению"
                                                                v-model="block.comment"></v-textarea>
                                                    <div v-else>{{ block.comment }}</div>
                                                </td>

                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    class="text-center">{{ block.minus }}
                                                </td>
                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'">{{
                                                    block.account_comment }}
                                                </td>
                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    class="text-center">{{ block.done }}
                                                </td>

                                            </tr>
                                            <tr class="yellow darken-3">
                                                <td>Итого ШБ:</td>
                                                <td class="text-center">{{ penaltySumm }}</td>
                                                <td class="text-left">{{ penaltySummCorrection }}</td>
                                                <td class="text-center">{{ penaltySummFinal }}</td>
                                                <td></td>
                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    class="text-center">{{ penaltySummAccountCorrection }}
                                                </td>
                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    class="text-center"></td>
                                                <td v-if="deal != null && deal.STAGE_ID === 'C30:2'"
                                                    class="text-center">{{ penaltySummDone }}
                                                </td>
                                            </tr>

                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-col>
                            </v-row>
                        </v-container>

                    </v-tab-item>
                    <v-tab-item value="tab-photo">
                        <v-card>
                            <v-container fluid>
                                <v-row>
                                    <v-col v-for="(fileObject, key) in images" :key="key" class="d-flex child-flex"
                                           cols="2">
                                        <v-card flat tile class="d-flex">
                                            <v-img v-if="fileObject.type !== 'additional'" style="cursor: pointer;"
                                                   :src="`https://sbotapi.fitauto.ru/v15/shopper/media_small/${fileObject.deal_id}/${fileObject.name}`"
                                                   @click="viewPhoto2({key, mode: 'telegram'})"
                                                   aspect-ratio="1" class="grey lighten-2">
                                                <template v-slot:placeholder>
                                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                                             color="grey lighten-5"></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                            <v-img v-else-if="fileObject.type === 'additional' && fileObject.file !== null && fileObject.small_file !== null"
                                                   style="cursor: pointer;"
                                                   :src="`https://sbotapi.fitauto.ru/v15/shopper/viewfile/${(fileObject.small_file !== null) ? fileObject.small_file : fileObject.file }/${fileObject.name}`"
                                                   @click="viewPhoto2({key, mode: 'telegram'})"
                                                   aspect-ratio="1" class="grey lighten-2">
                                                <template v-slot:placeholder>
                                                    <v-row class="fill-height ma-0" align="center" justify="center">
                                                        <v-progress-circular indeterminate
                                                                             color="grey lighten-5"></v-progress-circular>
                                                    </v-row>
                                                </template>
                                            </v-img>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row>
                                    <v-col cols="12">
                                        <h3>Загрузить еще фото</h3>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-textarea rows="2" v-model="dialogs.selectPhoto.small"
                                                    label="Маленький размер"></v-textarea>
                                    </v-col>

                                    <v-col cols="6">
                                        <v-textarea rows="2" v-model="dialogs.selectPhoto.big"
                                                    label="Большой размер"></v-textarea>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn color="success"
                                               :disabled="dialogs.selectPhoto.small === null || dialogs.selectPhoto.big === null"
                                               @click="addPhoto">Добавить фото
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card>

                    </v-tab-item>
                    <v-tab-item value="tab-audio">
                        <v-container fluid>
                            <v-row>
                                <v-col v-for="(file, key) in audio" :key="key" class="d-flex child-flex" cols="6">
                                    <v-card flat tile class="d-flex">
                                        <v-row>
                                            <v-col cols="6" v-if="file.file.indexOf('https://fit-service-bitrix') > -1">
                                                <audio :src="file.file" controls></audio>
                                            </v-col>
                                            <v-col cols="6" v-else>
                                                <audio :src="`https://sbotapi.fitauto.ru/v15/shopper/media/${file.deal_id}/${file.name}`" controls></audio>
                                            </v-col>

                                            <v-col cols="6" v-if="file.file.indexOf('https://fit-service-bitrix') > -1">
                                                <v-btn title="Конвертировать файл в mp3" @click="convertAudioToMp3(file.file, file.name, file)">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                                <v-btn :href="file.file"><v-icon>mdi-download</v-icon></v-btn>
                                                <v-btn @click="deleteThisAudio(file)"><v-icon>mdi-delete</v-icon></v-btn>
                                            </v-col>
                                            <v-col cols="6" v-else>
                                                <v-btn title="Конвертировать файл в mp3" @click="convertAudioToMp3(`https://sbotapi.fitauto.ru/v15/shopper/media/${file.deal_id}/${file.name}`, file.name, file)">
                                                    <v-icon>mdi-refresh</v-icon>
                                                </v-btn>
                                                <v-btn :href="`https://sbotapi.fitauto.ru/v15/shopper/media/${file.deal_id}/${file.name}`"><v-icon>mdi-download</v-icon></v-btn>
                                                <v-btn @click="deleteThisAudio(file)"><v-icon>mdi-delete</v-icon></v-btn>
                                            </v-col>
                                            <v-col cols="12">{{ file.name }}</v-col>
                                        </v-row>

                                    </v-card>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="8"><v-file-input v-model="newAudioFile" placeholder="Загрузить аудио"></v-file-input></v-col>
                                <v-col cols="4"><v-btn color="success" @click="loadAudio">Загрузить</v-btn></v-col>
                            </v-row>
                        </v-container>

                    </v-tab-item>
                    <v-tab-item value="tab-video">

                        <v-container fluid>
                            <v-row>
                                <v-col v-for="(file, key) in video" :key="key" class="d-flex child-flex" cols="6">
                                    <v-card flat tile class="d-flex">
                                        <video width="100%"
                                               :src="`https://sbotapi.fitauto.ru/v15/shopper/media/${file.deal_id}/${file.name}`"
                                               controls></video>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-container>

                    </v-tab-item>
                </v-tabs>
            </v-col>

            <LoaderModalDialog :text="loader.text" :show="loader.show"></LoaderModalDialog>

            <v-dialog v-model="dialogs.selectPhoto.show" scrollable max-width="800px">
                <v-card>
                    <v-card-title>Выберите фото:</v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height: 300px;">
                        <v-row>
                            <v-col v-for="(fileObject, key) in images" :key="key" class="d-flex child-flex" cols="3">
                                <v-card flat tile class="d-flex">
                                    <v-img v-if="fileObject.type !== 'additional'" style="cursor: pointer;"
                                           :src="`https://sbotapi.fitauto.ru/v15/shopper/media_small/${fileObject.deal_id}/${fileObject.name}`"
                                           @click="setPhoto(key)" aspect-ratio="1" class="grey lighten-2">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate
                                                                     color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                    <v-img v-else-if="fileObject.type === 'additional' && fileObject.file !== null && fileObject.small_file !== null"
                                           style="cursor: pointer;"
                                           :src="`https://sbotapi.fitauto.ru/v15/shopper/viewfile/${(fileObject.small_file !== null) ? fileObject.small_file : fileObject.file }/${fileObject.name}`"
                                           @click="setPhoto(key)" aspect-ratio="1" class="grey lighten-2">
                                        <template v-slot:placeholder>
                                            <v-row class="fill-height ma-0" align="center" justify="center">
                                                <v-progress-circular indeterminate
                                                                     color="grey lighten-5"></v-progress-circular>
                                            </v-row>
                                        </template>
                                    </v-img>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn color="blue darken-1" text @click="dialogs.selectPhoto.show = false">Отмена</v-btn>
                        <v-btn color="error" text @click="deletePhoto">Удалить файл из вопроса</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogs.viewPhoto.show" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="closeViewPhotoDialog">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Просмотр изображения</v-toolbar-title>
                    </v-toolbar>
                    <v-container fluid>
                        <v-row style="text-align: center;">
                            <v-col cols="12" style="text-align: center;">
                                <v-row>
                                    <v-col cols="12" class="text-center">
                                        <v-btn @click="prevImage" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-arrow-left-bold</v-icon>
                                        </v-btn>
                                        <v-btn @click="rotateLeft" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-rotate-left</v-icon>
                                        </v-btn>
                                        <v-btn @click="minusImage" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-magnify-minus-outline</v-icon>
                                        </v-btn>
                                        <v-btn @click="plusImage" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-magnify-plus-outline</v-icon>
                                        </v-btn>
                                        <v-btn @click="rotateRight" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-rotate-right</v-icon>
                                        </v-btn>
                                        <v-btn @click="nextImage" class="grey--text ma-1" color="grey lighten-3" dark>
                                            <v-icon>mdi-arrow-right-bold</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                                <img :width="dialogs.viewPhoto.width + `%`" ref="showimage" :src="dialogs.viewPhoto.source"/>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogs.viewComment.show" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Комментарий</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="dialogs.viewComment.comment" disabled rows="10"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogs.viewComment.show = false">Закрыть</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogs.editComment.show" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Комментарий</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="dialogs.editComment.comment" rows="10"
                                                placeholder="Напишите свой комментарий здесь"></v-textarea>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogs.editComment.show = false">Отмена</v-btn>
                        <v-btn color="blue darken-1" text @click="saveComment">Сохранить</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogs.addQuestion.show" persistent max-width="600px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Дополнительный вопрос</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea v-model="dialogs.addQuestion.question" rows="10"
                                                placeholder="Напишите текст вопроса, так как он будет отображен в акте"></v-textarea>
                                </v-col>
                                <v-col cols="12">
                                    <v-select :items="cats" label="Категория ШБ" v-model="dialogs.addQuestion.cat_id"
                                              item-text="cat_name" item-value="cat_id"></v-select>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="dialogs.addQuestion.show = false">Отмена</v-btn>
                        <v-btn color="blue darken-1"
                               :disabled="dialogs.addQuestion.question === null || dialogs.addQuestion.cat_id === null"
                               text @click="saveAddQuestion">Добавить вопрос
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>


        </v-row>
        <!-- IF NOT -->
        <v-row v-else>
            <LoaderModalDialog :text="loader.text" :show="loader.show"></LoaderModalDialog>
            <v-col cols="12"><h3>Отчет не доступен!</h3></v-col>
        </v-row>
    </div>
</template>
<script>
  import ShopperTableRow from '../components/ShopperTableRow'
  import ShopperTableSubHeader from '../components/ShopperTableSubHeader'
  import ShopperDocumentsRow from '../components/ShopperDocumentsRow'
  import ShopperShowTableBlock from '../components/ShopperShowTableBlock'
  import LoaderModalDialog from '../components/LoaderModalDialog'
  import generatePassword from 'password-generator'
  import ShopperAdditionalRow from '../components/ShopperAdditionalRow'
  import moment from 'moment'

  export default {
    components: {
      ShopperAdditionalRow,
      ShopperTableRow,
      ShopperTableSubHeader,
      ShopperDocumentsRow,
      ShopperShowTableBlock,
      LoaderModalDialog
    },
    data: () => ({
      standartQuestions: [],
      deleteMode: false,
      newAudioFile: null,
      mode: 'manager',
      dialogs: {
        addStandartQuestion: {
          loadQuestions: false,
          show: false,
          selectedQuestion: null,
          type: null,
        },
        selectFranchPhoto: {
          show: false,
          data: null,
          file: null,
        },
        password: {
          show: true,
          pass: null,
          symbols: false,
          error: false
        },
        selectPhoto: {
          show: false,
          data: null,
          small: null,
          big: null,
        },
        viewPhoto: {
          source: null,
          show: false,
          width: 40,
          deg: 0,
          key: 0,
        },
        editComment: {
          show: false,
          data: null,
          comment: null,
        },
        addQuestion: {
          show: false,
          question: null,
          cat_id: null,
        },
        viewComment: {
          show: false,
          comment: null,
        }
      },
      tab: null,
      api: 'https://sbotapi.fitauto.ru/v3/bots/shopper/',
      bxapi: 'https://fit-service-bitrix.ru/rest/1/c6cgmmggfa0owysa/',
      bot: 'https://sbotapi.fitauto.ru/v15/shopper/',
      loader: {
        show: false,
        text: 'Обновление отчета'
      },
      dealID: null,
      deal: null,
      cats: [],
      answers: [],
      adminquestions: [],
      adminsblocks: [],
      headEditor: {
        show: false,
        index: null,
        data: null,
      },
      addEditor: {
        show: false,
        index: null,
        data: null,
      },
      report: {
        firstInspection: false,
        testInspection: false,
        dealData: {},
        additionalQuestions: [],
        points: [],
        additional: [],
        head: [],
        sto: 0,
        final: {
          penalty: [],
          percents: [],
        },
        files: [],
      }
    }),
    filters: {
      sliceDate: function (value) {
        if (value) {
          return moment(value).format('DD.MM.YYYY')
        }
      }
    },
    computed: {
      // Подсчет общих ШБ ИТОГ
      penaltySummFinal () {
        let summ = 0
        for (let block of this.report.final.penalty) {
          summ = (+(summ) * 10 + +(block.final) * 10) / 10
        }
        return summ
      },
      penaltySummAccountCorrection () {
        let summ = 0
        for (let block of this.report.final.penalty) {
          summ = (+(summ) * 10 + +(block.minus) * 10) / 10
        }
        return summ
      },
      penaltySummDone () {
        let summ = 0
        for (let block of this.report.final.penalty) {
          summ = (+(summ) * 10 + +(block.done) * 10) / 10
        }
        return summ
      },
      // Подсчет общих баллов коррекции
      penaltySummCorrection () {
        let summ = 0
        for (let block of this.report.final.penalty) {
          summ = (+(summ) * 10 + +(block.correction) * 10) / 10
        }
        return summ
      },
      // Подсчет общих ШБ
      penaltySumm () {
        let summ = 0
        for (let block of this.report.final.penalty) {
          summ = (+(summ) * 10 + +(block.points) * 10) / 10
        }
        return summ
      },
      images () {
        let types = ['jpg', 'jpeg', 'png', 'tiff', 'gif', 'additional']
        return this.report.files.filter(file => types.indexOf(file.type.toLowerCase()) > -1)
      },
      audio () {
        let types = ['m4a', 'mp3', 'ogg', 'oga', '3gpp']
        return this.report.files.filter(file => types.indexOf(file.type.toLowerCase()) > -1)
      },
      video () {
        let types = ['mp4', 'avi', 'mov']
        return this.report.files.filter(file => types.indexOf(file.type.toLowerCase()) > -1)
      },
      computedHeaders () {
        return this.headers.map(row => {
          row.show = true
          if (row.hideStages && row.hideStages.indexOf(this.deal.STAGE_ID) > -1) row.show = false
          return row
        })
      },
      documentsRows () {
        let newRows = []
        let documentBlock = this.adminsblocks.filter(block => block.admin_block_id === 12)

        documentBlock = documentBlock[0]
        console.log('DOC BLOCK:', documentBlock)
        newRows.push({
          type: 'subHeader',
          data: documentBlock,
          mainpage: documentBlock.mainpage
        })

        let parents = this.report.points.filter(row => +(row.admin_block_id) === 12 && !row.parent_id)
        console.log('PARENTS', parents)
        if(documentBlock !== undefined) {
          for (let parent of parents) {
            newRows.push({
              type: 'row',
              data: parent,
              child: false,
              mainpage: documentBlock.mainpage
            })

            console.log('paren')

            if(parent.question_id) {
              let childs = this.report.points.filter(child => child.parent_id === parent.question_id)
              console.log(`PARENT ${parent.question_id} childs:`, childs)
              for (let child of childs) {
                newRows.push({
                  parentPoint: parent.point,
                  type: 'row',
                  data: child,
                  child: true,
                  mainpage: documentBlock.mainpage
                })
              }
            }
          }
        }
        console.log('DOCUMENT ROWS:', newRows)
        return newRows
      },
      showReport () {
        return (this.deal !== null && this.deal.CATEGORY_ID === '30' && (this.deal.STAGE_ID === 'C30:FINAL_INVOICE' || this.deal.STAGE_ID === 'C30:2' || this.deal.STAGE_ID === 'C30:1'))
      },
      additionalRows () {
        if (!this.report.additionalQuestions) this.report.additionalQuestions = []
        let newRows = this.report.additionalQuestions.map(r => {
          r.id = 1
          return r
        })
        return newRows
      },
      mainRows: function () {
        let newRows = []
        for (let block of this.adminsblocks) {
          if (block.mainpage === 1 && block.admin_block_id !== 10 && block.admin_block_id !== 11) {
            newRows.push({
              type: 'subHeader',
              data: block,
              mainpage: block.mainpage
            })
            for (let answer of this.report.points) {
              if (+(answer.admin_block_id) === +(block.admin_block_id)) newRows.push({
                type: 'row',
                data: answer,
                mainpage: block.mainpage
              })
            }
          }
        }
        return newRows
      },
    },
    watch: {
      tab() {
        console.log('tab,', this.tab)
        this.report.points = this.report.points.map((el, index) => {
          el.index = index
          return el
        })

        this.report.head = this.report.head.map((el, index) => {
          el.index = index
          return el
        })

        this.report.additional = this.report.additional.map((el, index) => {
          el.index = index
          return el
        })
        console.log('add', this.report.additional)
      }
    },
    methods: {
      deleteDoubleDoc: function (data) {
        console.log('delete row', data)
        this.report.points.splice(data.index, 1)
        this.updateIndexes()
      },
      deleteDouble: function (data) {
        console.log('delete row', data)
        this.report.points.splice(data.index, 1)
        this.updateIndexes()
      },
      addEditOn: function (index) {
        this.addEditor.index = index
        this.addEditor.show = true
        this.addEditor.data = JSON.parse(JSON.stringify(this.report.additional[index]))
      },
      addEditSave: function () {
        this.addEditor.show = false
        this.addEditor.index = null
        this.addEditor.data = null
        this.updateReport('addEditSave')
      },
      addEditCancel: function (index) {
        this.addEditor.show = false
        this.report.head[index] = JSON.parse(JSON.stringify(this.addEditor.data))
        console.log(this.report.additional[index])
        this.addEditor.index = null
        this.addEditor.data = null
      },
      headEditOn: function (index) {
        this.headEditor.index = index
        this.headEditor.show = true
        this.headEditor.data = JSON.parse(JSON.stringify(this.report.head[index]))
      },
      headEditSave: function () {
        this.headEditor.show = false
        this.headEditor.index = null
        this.headEditor.data = null
        this.updateReport('headEditSave')
      },
      headEditCancel: function (index) {
        this.headEditor.show = false
        this.report.head[index] = JSON.parse(JSON.stringify(this.headEditor.data))
        console.log(this.report.head[index])
        this.headEditor.index = null
        this.headEditor.data = null
      },
      deleteThisAudio: function (data) {
        let deleted = 0
        let audio = data
        for(let i in this.report.files) {
          let iterFile = this.report.files[i]
          if(iterFile.file === audio.file
            && iterFile.name === audio.name && deleted === 0) {
            this.report.files.splice(i, 1)
            deleted = 1
          }
        }
        //this.updateReport()
      },
      convertAudioToMp3: async function (url, name, fileData) {
        this.showLoaderDialog('Конвертируем файл...')
        try {
          console.log('data', {url, name, fileData})
          const r = await this.$http.post(`${this.$store.getters.api}v4/media/convert/tomp3`, {
            url: url,
            detail: name
          })
          console.log('converted', r.data)
          if(r.data.error) {
            alert('Ошибка конвертации файла: ' + r.data.error)
          } else {
            let fileName = r.data.result.NAME.split('.')
            this.report.files.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: fileName[fileName.length - 1],
              used: false,
            })
            this.deleteThisAudio(fileData)
          }
        } catch (e) {
          console.log(e)
        }
        this.hideLoaderDialog()
      },
      loadAudio: async function() {
        let data = this.newAudioFile
        console.log('FILE IS', data)
        let formData = new FormData()

        console.log('files', this.audio)
        let uploadURL, field
        console.log(uploadURL)
        console.log(field)
        this.showLoaderDialog('Загрузка файла')
        try {
          const r = await this.$http.post(`${this.bxapi}disk.folder.uploadfile?id=80614`)
          console.log('fileData', r.data)
          if(r.data.result) {
            uploadURL = r.data.result.uploadUrl
            field = r.data.result.field
            formData.append(field, this.newAudioFile, `${moment().format('YYYY_MM_DD_kk_mm_ss')}${this.newAudioFile.name}`)
          }
        } catch (e) {
          console.log('e')
        }

        if(field !== undefined) {
          try {
            const r = await this.$http.post(uploadURL,
              formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            )
            console.log('new file added', r.data)
            let fileName = r.data.result.NAME.split('.')

            this.report.files.push({
              file: r.data.result.DOWNLOAD_URL,
              name: r.data.result.NAME,
              type: fileName[fileName.length - 1],
              used: false,
            })
          } catch (e) {
            console.log(e)
          }
        }
        this.newAudioFile = null
        this.hideLoaderDialog()
      },
      moveFiles: async function () {
        await this.getAnswers(this.dealID)
        for (let answer of this.answers) {
          let filterMedia = this.report.files.filter(f => f.file === answer.file)
          if (filterMedia.length < 1 && answer.file !== null) {
            let small_file = (answer.small_file === null) ? answer.file : answer.small_file
            this.report.files.push({
              name: `basic_file_${this.report.files.length}.jpg`,
              file: answer.file,
              small_file: small_file,
              type: 'additional',
              used: false,
            })
          }
        }
        this.updateReport('moveFiles')
      },
      addPhoto: async function () {

        if (this.dialogs.selectPhoto.big !== null && this.dialogs.selectPhoto.small !== null) {
          this.report.files.push({
            name: `add_file_${this.report.files.length}.jpg`,
            file: this.dialogs.selectPhoto.big,
            small_file: this.dialogs.selectPhoto.small,
            type: 'additional',
            used: false,
          })

          this.dialogs.selectPhoto.big = null
          this.dialogs.selectPhoto.small = null

          this.updateReport('addPhoto')

          console.log('FILEZ:', this.report.files)
        } else {
          alert('Заполните оба поля')
        }

      },
      plusImage: function () {
        this.dialogs.viewPhoto.width += 10
      },
      minusImage: function () {
        this.dialogs.viewPhoto.width -= 10
      },
      closeViewPhotoDialog: function () {
        this.dialogs.viewPhoto.deg = 0
        this.dialogs.viewPhoto.show = false
      },
      rotateLeft: function () {
        this.dialogs.viewPhoto.deg = this.dialogs.viewPhoto.deg - 90
        this.$refs.showimage.style.transform = `rotate(${this.dialogs.viewPhoto.deg}deg)`
      },
      rotateRight: function () {
        this.dialogs.viewPhoto.deg += 90
        this.$refs.showimage.style.transform = `rotate(${this.dialogs.viewPhoto.deg}deg)`
      },
      nextImage: function () {
        let next = this.dialogs.viewPhoto.key + 1
        if(next > this.images[this.images.length - 1]) next = 0
        this.viewPhoto2({key: next, mode: 'telegram'})
        this.dialogs.viewPhoto.deg = 0
        this.$refs.showimage.style.transform = `rotate(${this.dialogs.viewPhoto.deg}deg)`
      },
      prevImage: function () {
        let next = this.dialogs.viewPhoto.key - 1
        if(next < 0) next = this.images[this.images.length - 1]
        this.viewPhoto2({key: next, mode: 'telegram'})
        this.dialogs.viewPhoto.deg = 0
        this.$refs.showimage.style.transform = `rotate(${this.dialogs.viewPhoto.deg}deg)`
      },
      // Распределение ШБ по категориям
      calculatePenalty: function () {
        for (let i in this.report.final.penalty) {
          if (this.report.final.penalty[i].id === 1) {
            let rows = this.report.points.filter(point => point.cat_id === 1 && !point.exclude && point.point === 0 && point.last_point < 1)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 1 && !point.exclude)
            this.report.final.penalty[i].points = ((+(rows.length) + +(addRows.length)) > 0) ? 1 : 0
          }
          if (this.report.final.penalty[i].id === 2) {
            let rows = this.report.points.filter(point => point.cat_id === 2 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 2 && !point.exclude)
            this.report.final.penalty[i].points = ((+(rows.length) + +(addRows.length)) > 0) ? 1 : 0
          }
          if (this.report.final.penalty[i].id === 3) {
            let rows = this.report.points.filter(point => point.cat_id === 3 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 3 && !point.exclude)
            this.report.final.penalty[i].points = ((+(rows.length) + +(addRows.length)) > 0) ? 1 : 0
          }
          if (this.report.final.penalty[i].id === 4) {
            let rows = this.report.points.filter(point => point.cat_id === 4 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 4 && !point.exclude)
            this.report.final.penalty[i].points = +(rows.length) + +(addRows.length)
          }
          if (this.report.final.penalty[i].id === 6) {
            let rows = this.report.points.filter(point => point.cat_id === 6 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 6 && !point.exclude)
            this.report.final.penalty[i].points = +(rows.length) + +(addRows.length)
          }
          if (this.report.final.penalty[i].id === 7) {
            let rows = this.report.points.filter(point => point.cat_id === 7 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 7 && !point.exclude)
            this.report.final.penalty[i].points = ((+(rows.length) + +(addRows.length)) >= 6) ? 1 : 0
          }
          if (this.report.final.penalty[i].id === 8) {
            this.report.final.penalty[i].points = 0
          }
          if (this.report.final.penalty[i].id === 18) {
            this.report.final.penalty[i].points = 0
          }
          if (this.report.final.penalty[i].id === 20) {
            let rows = this.report.points.filter(point => point.cat_id === 20 && !point.exclude && point.point === 0)
            let addRows = this.report.additionalQuestions.filter(point => point.cat_id === 20 && !point.exclude)
            this.report.final.penalty[i].points = ((+(rows.length) + +(addRows.length)) > 0) ? 1 : 0
          }

          this.report.final.penalty[i].final = (+(this.report.final.penalty[i].points) * 10 + +(this.report.final.penalty[i].correction) * 10) / 10
          this.report.final.penalty[i].done = (+(this.report.final.penalty[i].final) * 10 - +(this.report.final.penalty[i].minus) * 10) / 10
        }

        let summ_done = 0
        for (let block of this.report.final.penalty) {
          summ_done = (+(summ_done) * 10 + +(block.done) * 10) / 10
        }
        this.report.final.penalty_total = summ_done
        this.updateReport('calculatePenalty')
      },
      // Распределение Процентов
      calculatePercentage: function () {

        for (let i in this.report.final.penalty) {
          if (!this.report.final.penalty[i].minus) {
            this.report.final.penalty[i].minus = 0
            this.report.final.penalty[i].account_comment = null
            this.report.final.penalty[i].done = 0
          }
        }

        let standartQuestions = this.report.points.filter(point => point.admin_block_id !== 9)
        let excludedQuestions = standartQuestions.filter(point => point.exclude === true)
        let standartWOExcluded = standartQuestions.filter(point => point.exclude !== true)
        let bonusQuestions = this.report.points.filter(point => point.admin_block_id === 9)
        let standartPoints = 0
        for (let point of standartWOExcluded) {
          standartPoints += point.point_to_reports
        }

        let bonusPoints = 0
        for (let point of bonusQuestions) {
          bonusPoints += point.point_to_reports
        }

        let percent = (standartPoints + bonusPoints) / standartWOExcluded.length * 100

        this.report.final.percents = {
          allQuestions: standartQuestions.length,
          exluded: excludedQuestions.length,
          maximum: standartWOExcluded.length,
          bonus: bonusQuestions.length,
          standartPoints: standartPoints,
          bonusPoints: bonusPoints,
          finalPoints: standartPoints + bonusPoints,
          percent: Number(Math.round(percent + 'e2') + 'e-2')
        }
        this.calculatePenalty()
        //this.updateReport()
      },
      getDealID: async function () {
        this.showLoaderDialog(`Загрузка отчета`)

        this.dealID = this.$route.params.dealid

        await this.getDeal()
        await this.getReport()
        await this.getAdminsBlocks()
        this.hideLoaderDialog()
        console.log(this.report)
      },
      getDeal: async function () {
        try {
          this.showLoaderDialog('Загрузка сделки')
          this.hideLoaderDialog()
          const r = await this.$http.get(`${this.bxapi}crm.deal.get?id=${this.dealID}`)
          this.deal = r.data.result
        } catch (e) {
          this.deal = {
            ID: 108324,
            //STAGE_ID: 'C30:FINAL_INVOICE',
            STAGE_ID: 'C30:FINAL_INVOICE',
            CATEGORY_ID: '30',
            UF_CRM_1575264293: 123456,
            UF_CRM_1575264324: 12345678
          }
          console.log('Не могу загрузить сделку')
        }
      },
      showAddStandartQuestionDialog: function () {
        this.dialogs.addStandartQuestion.show = true
      },
      addStandartQuestion: async function () {
        console.log('qst is:', this.dialogs.addStandartQuestion.selectedQuestion)
        let answer = JSON.parse(JSON.stringify(this.dialogs.addStandartQuestion.selectedQuestion))
        console.log('add standart answer:', answer)
        let oldReport = await this.getLastReport(+(this.deal.UF_CRM_1555309977))

        if (answer.file !== null) {
          //Надо отправить файл в общие файлы
          let small_file = (answer.small_file === null) ? answer.file : answer.small_file
          this.report.files.push({
            name: `basic_file_${this.report.files.length}.jpg`,
            file: answer.file,
            small_file: small_file,
            type: 'additional',
            used: false,
          })
        }

        if (answer.admin_block_id !== 10 && answer.admin_block_id !== 11) {
          let newAnswer = {
            point: answer.point,
            last_point: (answer.admin_block_id === 9) ? 0 : 1,
            point_to_reports: answer.point,
            exclude: false,
            cat_id: answer.cat_id,
            comment: null,
            sto_comment: null,
            file: answer.file,
            sto_file: null,
            question: answer.question,
            answer: 'Нет',
            question_id: answer.step_id,
            admin_block_id: answer.admin_block_id,
            act_text: answer.act_text,
          }

          let newpoint = newAnswer.point > 0 ? 1 : 0

          if (newAnswer.admin_block_id === 9) {
            newAnswer.point = newpoint * 2
            newAnswer.point_to_reports = newpoint * 2
          } else {
            newAnswer.point = newpoint
            if (newAnswer.point === 0) {
              if (newAnswer.last_point > 0) newAnswer.point_to_reports = newpoint
              if (newAnswer.last_point <= 0) newAnswer.point_to_reports = newAnswer.last_point - 1
            } else {
              newAnswer.point_to_reports = newpoint
            }
          }

          if (!oldReport.error) {
            //Попробовать добавить значение из старого отчета
            let oldResult = oldReport.report.points.filter(point => point.question_id === newAnswer.question_id && point.admin_question_id === newAnswer.admin_question_id)
            if (oldResult[0]) {
              if (!!oldResult[0].exclude) {
                newAnswer.last_point = (answer.admin_block_id === 9) ? 0 : 1
                newAnswer.last_point_comment = oldResult[0].comment
              } else {
                newAnswer.last_point = oldResult[0].point_to_reports
              }
            }
          }

          this.report.points.push(newAnswer)
        } else if (answer.admin_block_id === 10) {
          this.report.additional.push(answer)
        } else if (answer.admin_block_id === 11) {
          this.report.head.push(answer)
        }

        console.log('sub docs', this.report.points.filter(p => p.parent_id > 0))

        this.updateIndexes()
        this.dialogs.addStandartQuestion.show = false
        this.dialogs.addStandartQuestion.selectedQuestion = null
        this.dialogs.addStandartQuestion.loadQuestions = false
        this.dialogs.addStandartQuestion.type = null
      },
      getQuestions: async function () {
        this.dialogs.addStandartQuestion.loadQuestions = true
        try {
          const r = await this.$http.get(`${this.api}stepsadmin/${this.dialogs.addStandartQuestion.type}`)
          this.standartQuestions = r.data
        } catch (e) {
          console.log(e)
        }
        this.dialogs.addStandartQuestion.loadQuestions = false
      },
      getAdminsBlocks: async function () {
        try {
          const r = await this.$http.get(`${this.api}adminsblocks`)
          this.adminsblocks = r.data
        } catch (e) {
          console.log(e)
        }
      },
      getAllFiles: async function () {
        try {
          const r = await this.$http.get(`${this.api}dealfiles/${this.dealID}`)
          let newFiles = r.data.map(file => {
            file.used = false
            return file
          })
          for (let file of newFiles) {
            this.report.files.push(file)
          }
        } catch (e) {
          console.log(e)
        }
      },
      getAnswers: async function (dealid) {
        try {
          const r = await this.$http.get(`${this.api}answers/${dealid}}`)
          this.answers = r.data
        } catch (e) {
          console.log(e)
        }
      },
      getLastReport: async function (sto_id) {
        try {
          const r = await this.$http.get(`${this.api}report/last/${sto_id}`)
          return r.data
        } catch (e) {
          console.log(e)
          return null
        }
      },
      createDefaultReport: async function () {
        await this.getAnswers(this.dealID) // Подгружаем вопросы в this.answers

        let oldReport = await this.getLastReport(+(this.deal.UF_CRM_1555309977)) // Ищем старый отчет

        if (!oldReport.error) {
          // Если есть старый отчет и в нем есть дополнительные вопросы, то пушим их в новый отчет заранее исключенными
          if (oldReport.report.additionalQuestions) {
            for (let qst of oldReport.report.additionalQuestions) {
              let oldQst = qst
              oldQst.exclude = true
              this.report.additionalQuestions.push(oldQst)
            }
          }
        }

        for (let answer of this.answers) {

          if (answer.file !== null) {
            //Надо отправить файл в общие файлы
            let small_file = (answer.small_file === null) ? answer.file : answer.small_file
            this.report.files.push({
              name: `basic_file_${this.report.files.length}.jpg`,
              file: answer.file,
              small_file: small_file,
              type: 'additional',
              used: false,
            })
          }

          if (answer.admin_block_id !== 10 && answer.admin_block_id !== 11) {
            let newAnswer = {
              point: answer.point,
              last_point: (answer.admin_block_id === 9) ? 0 : 1,
              point_to_reports: answer.point,
              exclude: false,
              cat_id: answer.cat_id,
              comment: null,
              sto_comment: null,
              file: answer.file,
              sto_file: null,
              question: answer.question,
              answer: answer.answer,
              question_id: answer.question_id,
              admin_block_id: answer.admin_block_id,
              act_text: answer.act_text,
            }

            let newpoint = newAnswer.point > 0 ? 1 : 0

            if (newAnswer.admin_block_id === 9) {
              newAnswer.point = newpoint * 2
              newAnswer.point_to_reports = newpoint * 2
            } else {
              newAnswer.point = newpoint
              if (newAnswer.point === 0) {
                if (newAnswer.last_point > 0) newAnswer.point_to_reports = newpoint
                if (newAnswer.last_point <= 0) newAnswer.point_to_reports = newAnswer.last_point - 1
              } else {
                newAnswer.point_to_reports = newpoint
              }
            }

            if (!oldReport.error) {
              //Попробовать добавить значение из старого отчета
              let oldResult = oldReport.report.points.filter(point => point.question_id === newAnswer.question_id && point.admin_question_id === newAnswer.admin_question_id)
              if (oldResult[0]) {
                if (!!oldResult[0].exclude) {
                  newAnswer.last_point = (answer.admin_block_id === 9) ? 0 : 1
                  newAnswer.last_point_comment = oldResult[0].comment
                } else {
                  newAnswer.last_point = oldResult[0].point_to_reports
                }
              }
            }

            this.report.points.push(newAnswer)
          } else if (answer.admin_block_id === 10) {
            this.report.additional.push(answer)
          } else if (answer.admin_block_id === 11) {
            this.report.head.push(answer)
          }
        }

        await this.getAdminQuestions()
        for (let question of this.adminquestions) {
          let newAnswer = {
            point: 0,
            last_point: (question.admin_block_id === 9) ? 0 : 1,
            point_to_reports: 0,
            exclude: false,
            comment: null,
            cat_id: question.cat_id,
            sto_comment: null,
            file: null,
            sto_file: null,
            question: question.question,
            answer: null,
            question_id: question.question_id,
            admin_question_id: question.question_id,
            admin_block_id: question.admin_block_id,
            parent_id: question.parent_id,
            act_text: question.act_text,
          }

          let newpoint = newAnswer.point > 0 ? 1 : 0

          if (newAnswer.admin_block_id === 9) {
            newAnswer.point = newpoint * 2
            newAnswer.point_to_reports = newpoint * 2
          } else {
            newAnswer.point = newpoint
            if (newAnswer.point === 0) {
              if (newAnswer.last_point > 0) newAnswer.point_to_reports = newpoint
              if (newAnswer.last_point <= 0) newAnswer.point_to_reports = newAnswer.last_point - 1
            } else {
              newAnswer.point_to_reports = newpoint
            }
          }

          if (!oldReport.error) {
            //Попробовать добавить значение из старого отчета
            let oldResult = oldReport.report.points.filter(point => point.question_id === newAnswer.question_id && point.admin_question_id === newAnswer.admin_question_id)
            if (oldResult[0]) {
              if (!!oldResult[0].exclude) {
                newAnswer.last_point = (question.admin_block_id === 9) ? 0 : 1
                newAnswer.last_point_comment = oldResult[0].comment
              } else {
                newAnswer.last_point = oldResult[0].point_to_reports
              }
            }
          }

          this.report.points.push(newAnswer)
        }

        this.report.points = this.report.points.map((el, index) => {
          el.index = index
          return el
        })

        this.report.head = this.report.head.map((el, index) => {
          el.index = index
          return el
        })

        this.report.additional = this.report.additional.map((el, index) => {
          el.index = index
          return el
        })

        this.report.sto = this.deal.UF_CRM_1555309977 // выбор сто
        this.createPasswords()
        await this.getBotDeal()
        await this.getCats()
        await this.getAllFiles()
        await this.updateReport('createDefaultReport')
      },
      createPasswords: async function () {
        try {
          const dealData = {
            id: this.dealID,
            fields: {
              UF_CRM_1575264293: generatePassword(6, false, /\d/),
              UF_CRM_1575264324: generatePassword(8, false, /\d/),
              UF_CRM_1576137828: generatePassword(10, false, /\d/),
            }
          }
          this.$http.post(`${this.bxapi}crm.deal.update`, dealData)
        } catch (e) {
          console.log(e)
        }
      },
      getAdminQuestions: async function () {
        try {
          const r = await this.$http.get(`${this.api}adminquestions`)
          this.adminquestions = r.data.map(qst => {
            qst.admin_question_id = qst.question_id
            return qst
          })
        } catch (e) {
          console.log(e)
        }
      },
      getReport: async function () {
        try {
          const r = await this.$http.get(`${this.api}report/${this.dealID}}`)
          if (!r.data.error) {
            this.report = r.data.report
            console.log('report loaded')
          } else {
            console.log('creating new report')
            await this.createDefaultReport() // Запустить создание отчета по умолчанию если отчета нет
            await this.sendReport()
          }
        } catch (e) {
          console.log(e)
        }
      },
      getBotDeal: async function () {
        try {
          const r = await this.$http.get(`${this.api}botdeal/${this.dealID}`)
          if (!r.data.error) {
            this.report.dealData = r.data
            this.report.dealData.real_start_date = this.report.dealData.real_start_date.substr(0, 10)
          }
        } catch (e) {
          console.log(e)
        }
      },
      getPenaltyCats: async function () {
        try {
          const r = await this.$http.get(`${this.api}cats`)
          this.cats = r.data
          console.log('cats', this.cats)
        } catch (e) {
          console.log(e)
        }
      },
      getCats: async function () {
        try {
          const r = await this.$http.get(`${this.api}cats`)

          for (let cat of r.data) {
            this.report.final.penalty.push({
              id: cat.cat_id,
              name: cat.cat_name,
              points: 0,
              correction: 0,
              final: 0,
              type: cat.type_id,
              comment: null,
              account_comment: null,
              minus: 0,
              done: 0,
            })
          }
        } catch (e) {
          console.log(e)
        }
      },
      sendReport: async function () {
        try {
          const r = await this.$http.post(`${this.api}report`, {
            deal_id_bx: this.dealID,
            report: this.report,
            sto: this.report.sto,
            test: (!!this.report.testInspection) ? 1 : 0
          })
        } catch (e) {
          console.log(e)
        }
      },
      showLoaderDialog: function (text = this.loaderText) {
        this.loader.text = text
        this.loader.show = true
      },
      hideLoaderDialog: function () {
        this.loader.show = false
      },
      updateIndexes: async function (update = false) {
        this.report.points = this.report.points.map((el, index) => {
          el.index = index
          return el
        })

        this.report.head = this.report.head.map((el, index) => {
          el.index = index
          return el
        })

        this.report.additional = this.report.additional.map((el, index) => {
          el.index = index
          return el
        })
        if(!!update) this.updateReport('updateIndexes')
      },
      updateReport: async function (log = null) {
        this.report.compilation = this.report.compilation + 1 || 0
        this.showLoaderDialog(`Обновление отчета`)
        try {
          const r = await this.$http.put(`${this.api}report`, {
            deal_id_bx: this.dealID,
            report: this.report,
            sto: this.report.sto,
            test: (!!this.report.testInspection) ? 1 : 0
          })
        } catch (e) {
          console.log(e)
        }
        this.hideLoaderDialog()
      },
      selectPhoto: async function (data) {
        console.log('select photo:', data)
        if (data.rows === 'points') {
          if (data.type === 'main') {
            this.dialogs.selectPhoto.show = true
            this.dialogs.selectPhoto.data = data
          }
          if (data.type === 'sto') {
            //this.report.points[data.index].sto_file
          }
        }
        if (data.rows === 'additionalQuestions') {
          if (data.type === 'main') {
            this.dialogs.selectPhoto.show = true
            this.dialogs.selectPhoto.data = data
          }
          if (data.type === 'sto') {
            //this.report.points[data.index].sto_file
          }
        }
      },
      deletePhoto: function () {
        let data = this.dialogs.selectPhoto.data
        console.log('delete photo data', data)
        if (data.rows === 'additionalQuestions') {
          this.report.additionalQuestions[data.index].file = null
        }
        if (data.rows === 'points') {
          this.report.points[data.index].file = null
        }
        this.dialogs.selectPhoto.show = false
        this.dialogs.selectPhoto.data = null
        this.updateReport('deletePhoto')
      },
      setPhoto: function (key) {
        let data = this.dialogs.selectPhoto.data
        console.log('setPhoto data', data)
        if (data.rows === 'points') {
          if (data.type === 'main') {
            this.report.points[data.index].file = this.images[key].file
            console.log('pointData ind', this.report.points[data.index])
            console.log('pointData ind-1', this.report.points[data.index - 1])
            this.dialogs.selectPhoto.show = false
            this.dialogs.selectPhoto.data = null
          }
          if (data.type === 'sto') {
            //this.report.points[data.index].sto_file
          }
        }

        if (data.rows === 'additionalQuestions') {
          if (data.type === 'main') {
            this.report.additionalQuestions[data.index].file = this.images[key].file
            this.dialogs.selectPhoto.show = false
            this.dialogs.selectPhoto.data = null
          }
          if (data.type === 'sto') {
            //this.report.points[data.index].sto_file
          }
        }

        this.updateReport('setPhoto')
      },
      viewPhoto: async function (data) {
        this.dialogs.viewPhoto.show = true
        if (data.mode === 'telegram') {
          this.dialogs.viewPhoto.source = `${this.bot}viewfile/${data.file}`
        } else {
          try {
            const r = await this.$http.get(`https://sbotapi.fitauto.ru/v3/bots/shopper/uploaded/${data.file}`)
            this.dialogs.viewPhoto.source = `data:image/jpeg;base64,${r.data.data}`
          } catch (e) {
            console.log(e)
          }
        }
      },
      viewPhoto2: async function (data) {
        this.dialogs.viewPhoto.show = true
        this.dialogs.viewPhoto.key = data.key
        if (data.mode === 'telegram') {
          console.log('image:', this.images[this.dialogs.viewPhoto.key])
          this.dialogs.viewPhoto.source = `${this.bot}viewfile/${this.images[this.dialogs.viewPhoto.key].file}`
        } else {
          try {
            const r = await this.$http.get(`https://sbotapi.fitauto.ru/v3/bots/shopper/uploaded/${data.file}`)
            this.dialogs.viewPhoto.source = `data:image/jpeg;base64,${r.data.data}`
          } catch (e) {
            console.log(e)
          }
        }
      },
      editComment: async function (data) {
        console.log('edit comment data', data)
        this.dialogs.editComment.show = true
        this.dialogs.editComment.data = data

        if (data.rows === 'additionalQuestions') {
          this.dialogs.editComment.comment = this.report.additionalQuestions[data.index].comment
        }

        if (data.rows === 'points') {
          this.dialogs.editComment.comment = this.report.points[data.index].comment
        }
      },
      saveComment: async function () {
        let data = this.dialogs.editComment.data

        if (data.rows === 'additionalQuestions') {
          this.report.additionalQuestions[data.index].comment = this.dialogs.editComment.comment
        }

        if (data.rows === 'points') {
          this.report.points[data.index].comment = this.dialogs.editComment.comment
        }

        this.updateReport('saveComment')
        this.dialogs.editComment = {
          show: false,
          comment: null,
          data: null,
        }
      },
      viewComment: function (data) {
        this.dialogs.viewComment.comment = data
        this.dialogs.viewComment.show = true
      },
      addAdditionalQuestion: function () {
        console.log('add question')
        this.dialogs.addQuestion.show = true
      },
      delAdditionalQuestion: async function (data) {
        console.log('dele', data)
        this.report.additionalQuestions.splice(data, 1)
      },
      saveAddQuestion: function () {
        this.report.additionalQuestions.push({
          question: this.dialogs.addQuestion.question,
          cat_id: this.dialogs.addQuestion.cat_id,
          exclude: false,
          comment: null,
          sto_comment: null,
          file: null,
          sto_file: null,
        })
        this.report.additionalQuestions = this.report.additionalQuestions.map((el, index) => {
          el.index = index
          return el
        })
        console.log('additional', this.report.additionalQuestion)
        this.dialogs.addQuestion = {
          show: false,
          question: null,
          cat_id: null,
        }
        this.updateReport('saveAddQuestion')
      }
    },
    created () {

    },
    mounted () {
      //this.checkCrypto()
      this.getDealID()
      this.getPenaltyCats()
      this.$emit('maincomponenthooks', { hideAppBar: true })
      //window.BX24.fitWindow()
    }
  }
</script>
<style>
    .rowBlock {
        background: #ffc107;
    }
</style>
